import {_} from 'i18n'
import React, {useCallback} from 'react'

import {ContainerHeader, DetailContainer, Paper} from '../styles'
import {Container} from './styles'

const CityContact = ({contacts}) => {
  const renderContact = useCallback(
    ({name, email, phone, mobile_phone, mobile_phone_2, linkedin, site, id}) => (
      <Container key={id}>
        <div style={{width: '100%'}}>
          <span className="secundary-title">{_`Nome do contato`}</span>
          <br />
          <span className="text-description-footer-1">{name}</span>
        </div>

        <div style={{width: '100%'}}>
          <span className="secundary-title">{_`Telefone`}</span>
          <br />
          {[phone, mobile_phone, mobile_phone_2].map((phoneItem, index) => (
            <span className="text-description-footer-1" key={`${id}-${phoneItem}-${index}`}>
              <a href={`tel:+55${phoneItem}`}>{phoneItem}</a>
            </span>
          ))}
        </div>

        <div style={{width: '100%'}}>
          <span className="secundary-title">{_`E-mail`}</span>
          <br />
          <span className="text-description-footer-1">
            <a href={`mailto:${email}`} style={{color: '#1E7BE1'}}>
              {email}
            </a>
          </span>
        </div>

        <div style={{width: '100%'}}>
          <span className="secundary-title">{_`Site`}</span>
          <br />
          <span className="text-description-footer-1">
            <a href={linkedin ? linkedin : site} target="_blank" rel="noopener noreferrer" style={{color: '#1E7BE1'}}>
              {linkedin ? linkedin : site}
            </a>
          </span>
        </div>
      </Container>
    ),
    [],
  )
  return (
    <Paper>
      <ContainerHeader>{_`Contatos da Empresa`}</ContainerHeader>
      <DetailContainer style={{paddingBottom: '1rem'}}>{contacts?.map(renderContact)}</DetailContainer>
    </Paper>
  )
}

export default CityContact
